const initialState = {
  loggedIn: false,
  loadedCredentials: false,
  loadingPlayers: false,
  finishedLoadingPlayers: false,
  redirected: false,
  displayedUser: null,
  activeUser: null,
  positions: null,
  conferences: null,
  states: null,
  statuses: null,
  players: [],
  hiddenPlayers: [],
  trackedPlayers: [],
  organization: { package: {} },
};

let tempy = JSON.parse(JSON.stringify(initialState));

export default function reducer(state = tempy, action) {
  switch (action.type) {
    case 'UPDATE_LOGGEDIN':
      return Object.assign({}, state, {
        loggedIn: action.loggedIn,
      });
    case 'UPDATE_LOADED_CREDENTIALS':
      return Object.assign({}, state, {
        loadedCredentials: action.loadedCredentials,
      });
    case 'LOADING_PLAYERS':
      return Object.assign({}, state, {
        loadingPlayers: action.loadingPlayers,
      });
    case 'FINISHED_LOADING_PLAYERS':
      return Object.assign({}, state, {
        finishedLoadingPlayers: action.finishedLoadingPlayers,
      });
    case 'UPDATE_REDIRECTED':
      return Object.assign({}, state, {
        redirected: action.redirected,
      });
    case 'UPDATE_ACTIVE_USER':
      return Object.assign({}, state, {
        activeUser: action.activeUser,
      });
    case 'UPDATE_DISPLAYED_USER':
      return Object.assign({}, state, {
        displayedUser: action.displayedUser,
      });
    case 'UPDATE_POSITIONS':
      return Object.assign({}, state, {
        positions: action.positions,
      });
    case 'UPDATE_CONFERENCES':
      return Object.assign({}, state, {
        conferences: action.conferences,
      });
    case 'UPDATE_STATES':
      return Object.assign({}, state, {
        states: action.states,
      });
    case 'UPDATE_STATUSES':
      return Object.assign({}, state, {
        statuses: action.statuses,
      });
    case 'UPDATE_PLAYERS':
      return Object.assign({}, state, {
        players: action.players,
      });
    case 'UPDATE_HIDDEN_PLAYERS':
      return Object.assign({}, state, {
        hiddenPlayers: action.hiddenPlayers,
      });
    case 'UPDATE_TRACKED_PLAYERS':
      return Object.assign({}, state, {
        trackedPlayers: action.trackedPlayers,
      });
    case 'UPDATE_ORG':
      return Object.assign({}, state, {
        organization: action.organization,
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/mainReducer.js